import * as React from 'react';
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { Input, Label, FormGroup, InputProps } from 'reactstrap';
import { Field, FieldArray, FieldProps } from 'formik';
import { isFieldValid } from 'common/utils/form';

export interface FormInputProps extends InputProps {
  label: React.ReactNode;
  name: string;
  id: string;
  nameValue: Array<any>;
}

export class FormInputArray extends React.Component<FormInputProps> {
  render() {
    const { id, label, name, children, nameValue, ...rest } = this.props;
    return (
      <FieldArray
        name={name}
        render={arrayHelpers => (
          <FormGroup>
            <Label for={id}>{label}</Label>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              style={{ marginLeft: 10 }}
              onClick={() => arrayHelpers.insert(0, '')}
            >
              +
            </button>
            {nameValue && nameValue.length > 0
              ? nameValue.map((value, index) => (
                  <div key={index}>
                    <Field name={`${name}.${index}`}>
                      {({ field, form }: FieldProps) => {
                        const invalid = !isFieldValid(form, name);
                        return (
                          <FormGroup>
                            <div className="row">
                              <div className="col">
                                <Input id={id} {...field} {...rest} invalid={invalid}>
                                  {children}
                                </Input>
                              </div>
                              <div className="col col-2 align-self-center">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  -
                                </button>
                              </div>
                            </div>
                            <FormErrorFeedback field={name} form={form} />
                          </FormGroup>
                        );
                      }}
                    </Field>
                  </div>
                ))
              : null}
          </FormGroup>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormInputArray.tsx